/**
 * textarea component for textarea macro in form.twig
 *
 */
document.addEventListener('alpine:init', () => {
    window.Alpine.data('textarea', (config) => ({
        placeholder: config.placeholder ?? '',
        init() {
            // set correct background label color
            window.domUtils.setBackgroundColor(this.$el);

            // init placeholder of textarea field and float label
            if(this.placeholder.length > 0) {
                this.$el.classList.add('is-focused');
            }
        },
    }));
});
